// extracted by mini-css-extract-plugin
export default {"table":"myPackTableList_table__Z8bW6"};